module.exports = __webpack_public_path__ + "img/map.b3e664e2.png";